import { render, staticRenderFns } from "./EtaDownloadRelatorio.vue?vue&type=template&id=b6e95196&scoped=true&"
import script from "./EtaDownloadRelatorio.vue?vue&type=script&lang=js&"
export * from "./EtaDownloadRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e95196",
  null
  
)

export default component.exports